// This file is automatically generated. Do not edit manually.

import { CustomerPriceGroupProfitMarginView } from "src/api/generated/erp/db/types/tables/customerPriceGroupProfitMarginView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerPriceGroupProfitMarginApi {
	export async function getProfitMargins(args: {
		customerPriceGroupId: number;
	}): Promise<Array<CustomerPriceGroupProfitMarginView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/masterData/customerPriceGroupProfitMargins/getProfitMargins",
			method: "POST",
			data: {
				customerPriceGroupId: args.customerPriceGroupId,
			},
		});
		return response as Array<CustomerPriceGroupProfitMarginView>;
	}

	export async function saveProfitMargins(args: {
		customerPriceGroupId: number;
		rows: Array<CustomerPriceGroupProfitMarginApi_SaveRow>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/masterData/customerPriceGroupProfitMargins/saveProfitMargins",
			method: "POST",
			data: {
				customerPriceGroupId: args.customerPriceGroupId,
				rows: args.rows,
			},
		});
		return response as void;
	}
}

export interface CustomerPriceGroupProfitMarginApi_SaveRow {
	profitMarginPercent: number | null | undefined;
	salesPartPriceGroupId: number;
}
